class StickyHeader extends HTMLElement {
  constructor() {
    super()

    this.selectors = {
      barCloseButton: '[data-header-bar-close]',
      navMobile: '[data-nav-mobile]',
      navMobileBack: '[data-nav-mobile-back]',
      navMobileButton: '[data-nav-button]',
      navMobileOverlay: '[data-nav-mobile-overlay]',
      headerBar: '[data-header-bar]',
      linkWithDropdown: '[data-link-has-dropdown]',
      navMobileDropdown: '[data-nav-mobile-dropdown]',
      mobileChatButton: '[data-mobile-chat-button]',
      navFirstLevelButton: '[data-nav-link-has-second-level]',
      navSecondLevelLink: '[data-nav-second-level-link]',
      navSecondLevelWrapper: '[data-nav-second-level-wrapper]',
      navOverlay: '[data-nav-overlay]',
      navThirdLevelMegamenu: '[data-nav-third-level-megamenu]',
      headerContainer: "[data-header-container]"
    }
    this.classes = {
      headerNavOpen: 'is-nav-open',
      headerScrolled: 'is-scrolled',
      navMobileActive: 'is-visible',
      navMobileDropdownBehind: 'under',
      navMobileDropdownVisible: 'current',
      navMobileButtonActive: 'is-active',
      hidden: 'hidden',
    }

  }

  connectedCallback() {

    // Elements
    this.barCloseButton = this.querySelector(this.selectors.barCloseButton)
    this.headerBar = this.querySelector(this.selectors.headerBar)
    this.navMobile = this.querySelector(this.selectors.navMobile)
    this.navMobileButton = this.querySelector(this.selectors.navMobileButton)
    this.navMobileOverlay = this.querySelector(this.selectors.navMobileOverlay)
    this.navMobileDropdown = Array.from(this.querySelectorAll(this.selectors.navMobileDropdown))

    // Handlers
    this.onScrollHandler = this.onScroll.bind(this)
    this.onBarCloseHandler = this.barClose.bind(this)
    this.toggleMenuHandler = this.toggleMenu.bind(this)
    this.linkWithDropdownHandler = this.linkWithDropdownOnClick.bind(this)
    this.toggleChatHandler = this.toggleChat.bind(this)
    this.linkWithMegamenuOpenHandler = this.linkWithMegamenuOnMouseEnter.bind(this)
    this.linkWithMegamenuCloseHandler = this.linkWithMegamenuOnMouseLeave.bind(this)
    this.collapseMobileDropdownsHandler =
      this.collapseMobileDropdowns.bind(this)
    this.calcPageOffset = this.calcPageOffset.bind(this)
    this.onEarlyAccessEnableHandler = this.onEarlyAccessEnable.bind(this);

    // Ref
    this.pastDropdowns = this.navMobileDropdown.filter((dropdown) => dropdown.hasAttribute('data-base-layer'));

    window.addEventListener('scroll', this.onScrollHandler, false)
    window.addEventListener('load', this.onScrollHandler, false)
    window.addEventListener('enableEarlyAccess', this.onEarlyAccessEnableHandler, false)
    this.barCloseButton.addEventListener('click', this.onBarCloseHandler, false)
    this.navMobileButton.addEventListener(
      'click',
      this.toggleMenuHandler,
      false
    )
    this.navMobileOverlay.addEventListener(
      'click',
      (e) => {
        this.toggleMenuHandler(e, true)
      },
      false
    )
    this.querySelectorAll(this.selectors.linkWithDropdown).forEach((link) => {
      link.addEventListener('click', this.linkWithDropdownHandler)
    })
    this.querySelectorAll(this.selectors.navMobileBack).forEach((button) => {
      button.addEventListener('click', this.collapseMobileDropdownsHandler)
    })
    this.querySelectorAll(this.selectors.mobileChatButton).forEach((button) => {
      button.addEventListener('click', this.toggleChatHandler);
    })

    this.headerBarClosed = window.sessionStorage.getItem('header-bar-closed')

    if (
      !this.headerBarClosed &&
      this.querySelector(this.selectors.headerBar).classList.contains(
        'has-content'
      )
    ) {
      this.headerBar.classList.remove(this.classes.hidden)
    }

    this.earlyAccessSession = window.sessionStorage.getItem('earlyAccess')
    if(this.earlyAccessSession) {
      this.onEarlyAccessEnable();
    }

    this.querySelector(this.selectors.headerContainer).addEventListener("mouseenter", () => {
      this.closeAllMegamenus();
    })

    this.querySelectorAll(this.selectors.navFirstLevelButton).forEach((link) => {
      link.addEventListener('click', (e) => {
        this.navFirstLevelButtonClick({e, link})
      })
    })


    this.querySelectorAll(this.selectors.navSecondLevelLink).forEach((link) => {
      link.addEventListener('mouseenter', this.linkWithMegamenuOpenHandler)
    })

    this.querySelectorAll(this.selectors.navThirdLevelMegamenu).forEach( (megamenu) => {
      megamenu.addEventListener('mouseleave', this.linkWithMegamenuCloseHandler)
    })

    window.addEventListener("resize", () => {
      this.setMaxHeightForMegamenus();
      this.calcPageOffset();
    })

    this.setMaxHeightForMegamenus();
    this.calcPageOffset();
    this.setCurrentOpenNavigation();

    const freeShippingContainer = document.getElementById('GlobaleFreeShippingBannerContainer');
    if (freeShippingContainer) {
      this.globaleBannerObserver = new MutationObserver((mutationsList) => {
        for(let mutation of mutationsList) {
          if (mutation.type === 'childList') {
            this.setMaxHeightForMegamenus();
            this.calcPageOffset();
          }
        }
      });

      const config = { childList: true, subtree: true };
      this.globaleBannerObserver.observe(freeShippingContainer, config);
    }
  }

  disconnectedCallback() {
    window.removeEventListener('scroll', this.onScrollHandler)
    window.removeEventListener('enableEarlyAccess', this.onEarlyAccessEnableHandler);

    if (this.globaleBannerObserver) {
      this.globaleBannerObserver.disconnect();
    }
  }

  setCurrentOpenNavigation() {
    const urlSearchParams = new URLSearchParams(window.location.search);
    const level1Ref = urlSearchParams.get('l1r');
    const level2Ref = urlSearchParams.get('l2r');
    if(level1Ref && level2Ref) {
      const firstLevelLink = document.querySelector(`[data-nav-link-has-second-level][title="${level1Ref}"]`)
      this.navFirstLevelButtonClick({link: firstLevelLink});
      document.querySelector(`.menu-level-2--opened [data-nav-second-level-link][title="${level2Ref}"]`).classList.add('nav__link--active');
    }
  }

  setMaxHeightForMegamenus() {
    this.querySelectorAll(this.selectors.navThirdLevelMegamenu).forEach((megamenu) => {
      this.calculateMaxHeightMegamenu(megamenu);
    })
  }

  calculateMaxHeightMegamenu(megamenu) {
    const headerHeight = this.calcHeaderHeight();
    const maxHeight = window.innerHeight - headerHeight;
    megamenu.style.setProperty("--maximum-height", `${maxHeight}px`)
  }

  toggleChat() {
    this.closeMenu();

    if (window.GorgiasChat) {
      window.GorgiasChat.open()
    }
  }

  onScroll() {
    const scrollTop = window.pageYOffset || document.documentElement.scrollTop

    this.classList.toggle(this.classes.headerScrolled, scrollTop > 0)
  }

  barClose() {
    this.headerBar.classList.add(this.classes.hidden)
    this.calcPageOffset()
    window.sessionStorage.setItem('header-bar-closed', true)
  }

  toggleMenu(e) {
    var headerHeight = this.closest('#shopify-section-header').offsetHeight
    this.navMobile.style.setProperty('--offset-top', `${headerHeight}px`);
    if(this.navMobile.classList.contains(this.classes.navMobileActive)) {
      this.closeMenu()
    } else {
      this.openMenu();
    }
  }

  openMenu() {
    this.navMobile.classList.add(this.classes.navMobileActive)
    this.navMobileButton.classList.add(this.classes.navMobileButtonActive)
    this.classList.add(this.classes.headerNavOpen)
    if(document.querySelector('#gorgias-chat-container')){
      document.querySelector('#gorgias-chat-container').style.display = "none";
    }

    if (typeof window.toggleBodyLock == 'function') {
      toggleBodyLock(this.navMobile, true);
    }
  }

  closeMenu() {
    this.navMobile.classList.remove(this.classes.navMobileActive)
    this.navMobileButton.classList.remove(this.classes.navMobileButtonActive)
    this.classList.remove(this.classes.headerNavOpen)

    this.navMobile.addEventListener('transitionend', () => {
      this.resetMobileNav();
    }, {once: true})

    if (typeof window.toggleBodyLock == 'function') {
      toggleBodyLock(this.navMobile, false);
    }

    if(document.querySelector('#gorgias-chat-container')){
      document.querySelector('#gorgias-chat-container').style.display = "block";
    }
  }

  resetMobileNav() {
    const firstLayerDropdown = this.navMobileDropdown.filter((dropdown) => dropdown.hasAttribute('data-base-layer'))
    this.pastDropdowns = firstLayerDropdown;

    this.navMobileDropdown.forEach((dropdown) => {
      dropdown.classList.remove(this.classes.navMobileDropdownVisible);
      dropdown.classList.remove(this.classes.navMobileDropdownBehind);
    })

    firstLayerDropdown[0].classList.add(this.classes.navMobileDropdownVisible);
    firstLayerDropdown[0].scrollTop = 0;
  }

  navFirstLevelButtonClick({e, link}) {
    if(e) {
      e.preventDefault();
    }

    this.closeAllMegamenus();
    this.closeAllSecondLevelNavs();
    this.deactivateFirstLevelLinks();
    const secondLevelMenuRef = link.dataset.navLinkMenuRef;
    const isActive = link.classList.contains("nav__link--active");
    const secondLevelMenu = this.querySelector(`[data-nav-second-level-ref="${secondLevelMenuRef}"]`);
    if (!isActive) {
      link.classList.add("nav__link--active");
      if (secondLevelMenu) {
        secondLevelMenu.classList.add("menu-level-2--opened")
      }
    }
  }

  linkWithDropdownOnClick(e) {
    e.preventDefault()

    const targetHandle = e.currentTarget.dataset.handle;

    const targetDropdown = this.navMobileDropdown.find((dropdown) => dropdown.dataset.handle === targetHandle);

    if (!targetDropdown) {
      return
    }

    this.pastDropdowns.forEach((drawer) => {
      drawer.classList.add(this.classes.navMobileDropdownBehind);
      drawer.classList.remove(this.classes.navMobileDropdownVisible);
    })

    targetDropdown.classList.add(this.classes.navMobileDropdownVisible);
    targetDropdown.scrollTop = 0;
    this.pastDropdowns.push(targetDropdown);
  }

  collapseMobileDropdowns(e) {
    const latestDropdown = this.pastDropdowns.pop();

    latestDropdown.classList.remove(this.classes.navMobileDropdownVisible);

    this.pastDropdowns.slice(-1)[0].classList.remove(this.classes.navMobileDropdownBehind);
    this.pastDropdowns.slice(-1)[0].classList.add(this.classes.navMobileDropdownVisible);
  }

  closeAllMegamenus() {
    const overlay = this.querySelector(this.selectors.navOverlay);
    overlay.classList.remove("active");

    document.querySelectorAll(this.selectors.navThirdLevelMegamenu).forEach((megamenu) => {
      megamenu.classList.remove("opened")
    })
    document.querySelectorAll(this.selectors.navSecondLevelWrapper).forEach((menu) => {
      menu.classList.remove("has-third-level-opened")
    })
    document.querySelectorAll(this.selectors.navSecondLevelLink).forEach((link) => {
      link.classList.remove("opened")
    })
  }

  closeAllSecondLevelNavs() {
    document.querySelectorAll(this.selectors.navSecondLevelWrapper).forEach((secondLevelMenu) => {
      secondLevelMenu.classList.remove("menu-level-2--opened")
    })
  }

  deactivateFirstLevelLinks() {
    document.querySelectorAll(this.selectors.navFirstLevelButton).forEach((secondLevelMenu) => {
      secondLevelMenu.classList.remove("nav__link--active")
    })
  }

  linkWithMegamenuOnMouseEnter(e) {
    const currentLink = e.target;
    const secondLevelWrapper = currentLink.closest(this.selectors.navSecondLevelWrapper);
    const megaMenuRef = currentLink.dataset.dropdownId;
    const thirdLevelMegamenu = currentLink.closest("[data-nav-second-level-wrapper]").querySelector(`[data-nav-third-level-megamenu="${megaMenuRef}"]`);
    const overlay = this.querySelector(this.selectors.navOverlay);
    const hasSomeThirdLevelMenuActive = this.querySelector(`${this.selectors.navThirdLevelMegamenu}.opened`);
    const hasSomeSecondLevelLinkActive = this.querySelector(`${this.selectors.navSecondLevelLink}.opened`);

    if (hasSomeThirdLevelMenuActive) {
      hasSomeThirdLevelMenuActive.classList.remove("opened");
      hasSomeSecondLevelLinkActive.classList.remove("opened");
    }

    if (!thirdLevelMegamenu) {
      secondLevelWrapper.classList.remove("has-third-level-opened");
      overlay.classList.remove("active");
      if (hasSomeSecondLevelLinkActive) {
        hasSomeSecondLevelLinkActive.classList.remove("opened");
      }
      return;
    }

    const isOpened = thirdLevelMegamenu.classList.contains("opened");
    if (!isOpened) {
      currentLink.classList.add("opened");
      thirdLevelMegamenu.classList.add("opened");
      overlay.classList.add("active");
      secondLevelWrapper.classList.add("has-third-level-opened");

      const gorgiasChatContainer = document.getElementById('gorgias-chat-container');
      if (gorgiasChatContainer) {
        gorgiasChatContainer.style.zIndex = 10;
      }
    }
  }

  linkWithMegamenuOnMouseLeave(e) {
    const currentElement = e.fromElement;
    const secondLevelLinkActive = this.querySelector(`${this.selectors.navSecondLevelLink}.opened`);
    const secondLevelWrapper = currentElement.closest(this.selectors.navSecondLevelWrapper);
    const overlay = this.querySelector(this.selectors.navOverlay);

    const gorgiasChatContainer = document.getElementById('gorgias-chat-container');
    if (gorgiasChatContainer) {
      gorgiasChatContainer.removeAttribute('style');
    }

    const isOpened = currentElement.classList.contains("opened");
    if (isOpened && e.toElement && !e.toElement.contains(currentElement)) {
      secondLevelLinkActive?.classList?.remove("opened");
      currentElement.classList.remove("opened");
      secondLevelWrapper.classList.remove("has-third-level-opened");
      overlay.classList.remove("active");
    }
  }

  calcHeaderHeight() {
    const openedMenu = this.querySelector('.menu-level-2--opened');
    let headerHeight = this.closest('#shopify-section-header').offsetHeight

    if (openedMenu && openedMenu.offsetHeight) {
      headerHeight += openedMenu.offsetHeight
    }

    return headerHeight;
  }

  calcPageOffset() {
    const main = document.querySelector('#MainContent')
    const headerHeight = this.calcHeaderHeight();

    main.style.paddingTop = `${headerHeight}px`

    this.calcAccountTop(headerHeight)
  }

  calcAccountTop(headerHeight) {
    const accountTabs = document.querySelectorAll('.js-account-tab')

    if (accountTabs && accountTabs[0]) {
      accountTabs.forEach((element) => {
        element.style.marginTop = `-${headerHeight}px`
        element.style.paddingTop = `${headerHeight}px`
      })
    }
  }

  onEarlyAccessEnable() {
    const earlyAccessButtons = this.querySelectorAll('.early-access');

    earlyAccessButtons.forEach(element => {
      element.classList.remove('hidden');
    })
  }
}

customElements.define('sticky-header', StickyHeader)
